<template>
    <div>
        <form @submit.prevent="claimListing" enctype="multipart/form-data" class="contact-form">
            <div class="input-field">
                <label for="claimant_name">Your Name</label>
                <input type="text" name="name" id="claimant_name" class="form-control" v-model="claim.username">
            </div>
            <div class="input-field">
                <label for="claimant_email">Your Email</label>
                <input type="email" name="email" id="claimant_email" class="form-control" v-model="claim.useremail">
            </div>
            <div class="input-field" style="max-height: 43px">
                <v-app>
                    <v-autocomplete
                            v-model="model"
                            :loading="isLoading"
                            :search-input.sync="search"
                            :items="items"
                            :item-value="items => items.store_name +' - '+ items.store_address"
                            :item-text="items => items.store_name +' - '+ items.store_address"
                            outlined
                            attach
                            dense
                            chips
                            small-chips
                            label="Type in store name..."
                            multiple
                    ></v-autocomplete>
                </v-app>
            </div>
            <div class="input-field">
                <label for="message">Message</label>
                <textarea type="text" name="message" id="message" class="materialize-textarea form-control" rows="10" v-model="claim.message"></textarea>
            </div>
            <div class="input-field">
                <button type="submit" class="btn btn-primary waves-effect waves-light">Send</button>
            </div>
        </form>
    </div>

</template>
<script>
export default {

    props: ['username', 'useremail'],
    data(){
        return {
            isLoading: false,
            items: [],
            model: null,
            search: null,
            claim: {
                username: this.username ? this.username : '',
                useremail: this.useremail ? this.useremail : '',
                message: '',
            }
        }
    },
    computed: {
        fields () {
            if (!this.model) return []
            return Object.keys(this.model).map(key => {
                    return {
                        key: key,
                        value: this.model[key] || 'n/a'
                    }
                })
        }
    },
    watch: {
        search (val) {
            // Items have already been loaded
            // Items have already been requested
            if (this.isLoading) return;
            this.isLoading = true;
            // Lazily load input items

            axios.get('/api/listingSearch',{params: {query: this.search}})
                .then(res => {
                this.items = res.data
                })
                .catch(err => {
                        console.log(err)
                })
                .finally(() => (this.isLoading = false))

        }
    },
    methods: {
        claimListing() {
            axios.post('/api/submitclaim',{
                name: this.claim.username,
                email   : this.claim.useremail,
                stores: this.model,
                message: this.claim.message
            }).then(response => {
                swal(
                    'Success!',
                    'We will get back to you shortly',
                    'success'
                );
            })
            .catch(error => {
                console.log(error);
                    /*let errer_messae = error.response.data.errors.message;
                    swal(
                        'Whoops!',
                        errer_messae[0],
                        'warning'
                    );*/
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ClaimListing.vue